export const STATUS = {
    COMPLETED: 'completed',
    IN_PROGRESS: 'in-progress',
    SCHEDULED: 'scheduled',
    DISABLED: 'disabled',
};
